<template>
    <div class="relative">
        <span class="hidden sm:inline-block cursor-pointer" @click.stop="togglePopup">{{ selectedLang }}</span>

        <select v-model="$i18n.locale" v-on:change="selectedChange" class="inline-block sm:hidden md:hidden bg-transparent">
            <template v-for="(locale, i) in locales">
                 <option :key="`lang-${i}`" :value="locale.code">{{ locale.name }}</option>
            </template>
        </select>

        <div v-if="isOpen" @click.stop class="absolute hidden sm:block ml-auto right-0 dropdown bg-white text-left rounded p-4">
            <template v-for="(locale, i) in locales">
                <div :key="`lang-${i}`">
                    <input
                        :id="`lang-${i}`"
                        type="radio"
                        name="lang"
                        :value="locale.code" v-model="$i18n.locale" v-on:change="selectedChange" />
                    <label class="block mb-2 grey cursor-pointer flex items-center" :for="`lang-${i}`">
                        {{ locale.name }}
                        <svg class="hidden icon ml-auto"><use xlink:href="#checked" /></svg>
                    </label>
                </div>
            </template>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" class="hidden">
            <symbol id="checked" height="12" viewBox="0 0 12 12" width="12">
                <path d="m5.995 0c-3.31 0-5.995 2.684-5.995 5.995s2.684 5.996 5.995 5.996c3.312 0 5.996-2.685 5.996-5.996-.001-3.31-2.684-5.995-5.996-5.995zm-1.1 9.075-2.64-2.64.88-.88 1.76 1.76 3.96-3.96.88.88z"
                    fill="currentColor" />
            </symbol>
        </svg>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/color';

.dropdown {
    width: 140px;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    input {
        display: none;
        &:checked {
            & + label {
                color: $blue-dark;
                svg {
                    display: inline-block;
                }
            }
        }
    }

    .icon {
        width: 12px;
        height: 12px;
    }
}
</style>

<script>
export default {
    data () {
        return {
            isOpen: false,
            locales: []
        }
    },
    computed: {
        selectedLang () {
            const selected = this.locales.find(l => l.code === this.$i18n.locale);

            if (selected) {
                return selected.name
            }

            return this.locales[0].name
        }
    },
    methods: {
        togglePopup () {
            this.isOpen = !this.isOpen
        },
        selectedChange (e) {
            this.isOpen = false
            this.$store.dispatch('changeLanguage', e.target.value)
        }
    },
    watch: {
        '$store.state.lang' (lang) {
            this.$i18n.locale = lang;
        }
    },
    created () {
        const localeCodes = process.env.VUE_APP_SUPPORTED_LANG.split(',')
        const localeName = process.env.VUE_APP_SUPPORTED_LANG_NAME.split(',')

        localeCodes.forEach((locale, index) => {
            this.locales.push({
                code: locale,
                name: localeName[index]
            })
        })
    },
    mounted () {
        document.addEventListener('click', () => this.isOpen = false)
    }
}
</script>
